import React, { useEffect, useState } from 'react'
import CustomNavbar from './PublicNavbar'
import { useDispatch, useSelector } from 'react-redux'
import { userBioLinkDetails } from '../../redux/slice/UserBioLinkDetails'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import ChatBox from '../followers/Chatbox'
import { toast } from 'react-toastify'
import '../../assets/css/UserBiolinkPage.css'
import PrivateNavbar from './Navbar'
import { followUser } from '../../redux/slice/FollowUser'
import ButtonLoader from '../../components/loader/ButtonLoader'
import Loader from '../../components/loader/Loader'
import { biolinkAnalytics } from '../../redux/slice/BioLinkAnalytics'
import { youtubeAnalytics } from '../../redux/slice/YoutubeAnalytic'
import { socialAnalytics } from '../../redux/slice/SocialAnalytic'
import { FaBan, FaCheck, FaComments, FaTimes, FaUserMinus } from 'react-icons/fa'
import { Badge, Button } from 'react-bootstrap'
import { Clock12 } from 'lucide-react'
import thumbImage from '../../../src/assets/images/hand3.png'
import defaultProfile from '../../../src/assets/images/1 Logo AD1.png'
import defaultBanner from '../../../src/assets/images/1 Bill AD1.png'
import { chatNotification } from '../../redux/slice/ChatNotification'
import Footer from './Footer'

export default function UserBiolLinkPage() {
    const user_token = localStorage.getItem('token')
    const [loading, setLoading] = useState(false)
    const [analyticsId, setAnalyticsId] = useState('')
    const [showChat, setShowChat] = useState(false)
    const dispatch = useDispatch()
    const [spinner, setspinner] = useState(false)
    const [bool, setBool] = useState(false)
    const navigate = useNavigate()
    const { id } = useParams()
    const location = useLocation()
    const userbiolinkDataArray = useSelector((state) => state.userBioLinkDetails.data)
    const chatNotificationData = useSelector(state => state?.chatNotification?.data?.[0])
    const userbiolinkData = userbiolinkDataArray?.[0]
    const bioLinkdata = userbiolinkData?.profileData?.[0]
    const followerData = userbiolinkData?.FollowerData?.[0]
    const background_type = bioLinkdata?.background_type
    const selectedBackground = bioLinkdata?.background_color
    const selectedFontFamily = bioLinkdata?.font_family
    const font_color = bioLinkdata?.font_color
    const profilePhoto = bioLinkdata?.profile_photo
    const showProfilePhoto = bioLinkdata?.show_profile_photo
    const title = bioLinkdata?.title
    const showTitle = bioLinkdata?.show_title
    const paragraph = bioLinkdata?.about_us
    const showParagraph = bioLinkdata?.show_paragraph
    const bannerImage = bioLinkdata?.banner_image
    const showBanner = bioLinkdata?.show_banner
    const socialLinks = bioLinkdata?.social_links || []
    const youtubeVideos = bioLinkdata?.youtube_videos || []

    console.log('bannerImage', bannerImage)

    // Get full-width background style
    const getBackgroundStyle = () => {
        if (background_type === 'solid') {
            return { backgroundColor: selectedBackground || '#f8f9fa' }
        } else {
            return { background: selectedBackground || 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }
        }
    }


    // Get font family style
    const getFontStyle = () => {
        return {
            fontFamily: selectedFontFamily || 'Arial, sans-serif',
            color: font_color || '#000000'
        }
    }

    // Get profile image URL
    const getProfileImageUrl = () => {
        if (profilePhoto) {
            return profilePhoto.startsWith('http')
                ? profilePhoto
                : process.env.REACT_APP_BASE_URL + profilePhoto
        }
        return null
    }

    // Get banner image URL
    const getBannerImageUrl = () => {
        if (bannerImage) {
            return bannerImage.startsWith('http')
                ? bannerImage
                : process.env.REACT_APP_BASE_URL + bannerImage
        }
        return null
    }

    // Get initials for avatar
    const getInitials = (name) => {
        if (!name) return 'U'
        const names = name.split(' ')
        if (names.length >= 2) {
            return (names[0][0] + names[names.length - 1][0]).toUpperCase()
        }
        return name.substring(0, 2).toUpperCase()
    }

    useEffect(() => {
        setLoading(true)
        dispatch(userBioLinkDetails({ username: id, navigate })).then((res) => list_res(res.payload))
    }, [bool, id, navigate, dispatch])

    const analytics_res = (res) => {
        if (res?.status == 200) {
            setAnalyticsId(res?.data?.data?.AnalyticsProfile_id)
        }
    }


    const list_res = (res) => {
        console.log('res', res)
        if (res?.status == 200) {
            // setLoading(false)
            if (res?.data?.data?.[0]?.profileData?.[0]?.user?.status === 'Inactive') {
                navigate('/home')
            } else {
                dispatch(biolinkAnalytics({ user_name: id })).then((res) => analytics_res(res.payload))
                setLoading(false)

            }
        } else {
            setLoading(false)
        }
    }

    const profileImageUrl = getProfileImageUrl()
    const bannerImageUrl = getBannerImageUrl()
    const initials = getInitials(title)

    const backgroundStyle = getBackgroundStyle()
    const fontStyle = getFontStyle()
    const combinedStyle = { ...backgroundStyle, ...fontStyle }

    const handle_login = () => {
        navigate('/login', { state: { from: location.pathname } })
    }

    const handleFollow = () => {
        setspinner(true)
        dispatch(followUser({
            follower_id: localStorage.getItem('id'),
            following_id: bioLinkdata?.user?._id,
            status: 'follow',
        })).then((res) => follow_res(res.payload))
    }
    const handleAccept = () => {
        setspinner(true)
        dispatch(followUser({
            follower_id: bioLinkdata?.user?._id,
            following_id: localStorage.getItem('id'),
            status: 'accepted',
        })).then((res) => follow_res(res.payload))
    }
    const handleUnfollow = () => {
        setspinner(true)
        dispatch(followUser({
            follower_id: localStorage.getItem('id'),
            following_id: bioLinkdata?.user?._id,
            status: 'unfollow',
        })).then((res) => follow_res(res.payload))
    }

    const handleBlock = () => {
        setspinner(true)
        dispatch(followUser({
            follower_id: localStorage.getItem('id'),
            following_id: bioLinkdata?.user?._id,
            status: 'blocked',
        })).then((res) => follow_res(res.payload))
    }
    const handleReject = () => {
        setspinner(true)
        dispatch(followUser({
            follower_id: localStorage.getItem('id'),
            following_id: bioLinkdata?.user?._id,
            status: 'rejected',
        })).then((res) => follow_res(res.payload))
    }
    const handleUnBlock = () => {
        setspinner(true)
        dispatch(followUser({
            follower_id: localStorage.getItem('id'),
            following_id: bioLinkdata?.user?._id,
            status: 'unblocked',
        })).then((res) => follow_res(res.payload))
    }
    const follow_res = (res) => {
        if (res.status == 200 || res.status == 201) {
            toast.success(res?.data?.message, { position: "bottom-right" });
            setBool(!bool)
            setspinner(false)

        } else {
            toast.error(res?.data?.message, { position: "bottom-right" });
            setspinner(false)
        }
    }



    const handleChat = () => {
        if (user_token) {
            setShowChat(true)
        } else {
            handle_login()
        }
    }

    const handleCloseChat = () => {
        setShowChat(false)
    }

    const getProfileImage = (f) => {
        const user = f?.user || {}
        const profile = user?.profile || {}
        const profilePhoto = profile?.profile_photo || user?.profile_photo || f?.profile_photo

        if (profilePhoto) {
            return profilePhoto.startsWith('http')
                ? profilePhoto
                : `${process.env.REACT_APP_BASE_URL}/${profilePhoto}`
        }
        return null
    }



    // Create follower object from bioLink data for chat
    const chatFollower = bioLinkdata ? {
        _id: bioLinkdata?.user?._id,
        name: bioLinkdata?.user?.name,
        initials: getInitials(bioLinkdata?.user?.name),
        profile_photo: profileImageUrl ? profileImageUrl : getProfileImage(bioLinkdata),
    } : null




    useEffect(() => {
        const interval = setInterval(() => {
            if (localStorage.getItem('id')) {
                dispatch(chatNotification({ navigate }))
            }
        }, 5000);
        return () => clearInterval(interval);
    }, [])


    return (
        <>
            {user_token ? <PrivateNavbar dashboard={true} userBioLink={true} /> : <CustomNavbar />}
            {loading ?
                <Loader /> :
                (!userbiolinkData || !userbiolinkDataArray || userbiolinkDataArray.length === 0) ?
                    <div className="user-biolink-page" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <div style={{ textAlign: 'center', padding: '40px' }}>
                            <h2 style={{ fontSize: '24px', color: '#333', marginBottom: '16px' }}>Profile not created</h2>
                        </div>
                    </div> :
                    <div className="user-biolink-page" style={combinedStyle}>




                        {/* Main Content - Single Section */}
                        <div className="container" style={{ marginTop: '-3px' }}>
                            <div className="row">
                                <div className="col-md-12">


                                    <div className="user-biolink-content mt-2">
                                        {/* Profile and Title Section */}
                                        <div className="d-flex justify-content-center align-items-center user-biolink-profile-title-wrapper">
                                            {showProfilePhoto === true || showProfilePhoto === 'true' ? (
                                                <img
                                                    src={profilePhoto ? profileImageUrl : defaultProfile}
                                                    alt={'Profile'}
                                                    className="user-biolink-profile-image"
                                                    style={{ objectFit: profilePhoto ? 'cover' : 'contain' }}
                                                    onError={(e) => {
                                                        e.target.style.display = 'none'
                                                        e.target.nextSibling.style.display = 'flex'
                                                    }}
                                                />
                                            ) :
                                                ''}
                                            {/*  */}
                                            <div className="ms-4 user-biolink-title-wrapper">
                                                {showTitle === true || showTitle === 'true' ?
                                                    <h1 className="user-biolink-title">{title}</h1>
                                                    : ''}
                                                <div className="user-biolink-action-buttons">

                                                    {
                                                        localStorage.getItem('id') === bioLinkdata?.user?._id ? "" :
                                                            userbiolinkData?.FollowerData?.length == 0 || followerData?.user_status === 'unfollow' ?
                                                                <button className="user-biolink-social-link follower-action-btn-bio" onClick={() => user_token ? handleFollow() : handle_login()}>
                                                                    {spinner ?
                                                                        <ButtonLoader />
                                                                        : 'Follow'}
                                                                </button> :
                                                                followerData?.follower_id?._id === localStorage.getItem('id') && followerData?.user_status === 'follow' ?
                                                                    // <button className="user-biolink-chat-btn" onClick={() => user_token ? handleUnfollow() : handle_login()}>
                                                                    //     {spinner ?
                                                                    //         <ButtonLoader />
                                                                    //         : 'Unfollow'}
                                                                    // </button>
                                                                    <Button
                                                                        variant="warning"
                                                                        className="follower-action-btn-bio follower-unfollow-btn"
                                                                        onClick={() => user_token ? handleUnfollow() : handle_login()}
                                                                    >
                                                                        <FaUserMinus className="me-2" />
                                                                        Unfollow
                                                                    </Button>
                                                                    :
                                                                    followerData?.following_id?._id == localStorage.getItem('id') && followerData?.user_status === 'pending' ?
                                                                        <Button
                                                                            variant="danger"
                                                                            className="follower-action-btn-bio"
                                                                            onClick={() => user_token ? handleReject() : handle_login()}
                                                                        >
                                                                            <FaTimes className="me-2" />
                                                                            Reject
                                                                        </Button> :
                                                                        followerData?.following_id?._id == localStorage.getItem('id') && followerData?.user_status === 'follow' ?
                                                                            // <button className="btn btn-danger" onClick={() => user_token ? handleBlock() : handle_login()}>
                                                                            //     {spinner ?
                                                                            //         <ButtonLoader />
                                                                            //         : 'Block'}
                                                                            // </button> 
                                                                            <Button
                                                                                variant="danger"
                                                                                className="follower-action-btn-bio"
                                                                                onClick={() => user_token ? handleBlock() : handle_login()}
                                                                            >
                                                                                <FaTimes className="me-2" />
                                                                                Block
                                                                            </Button>
                                                                            :
                                                                            followerData?.following_id?._id == localStorage.getItem('id') && followerData?.user_status === 'blocked' ?
                                                                                // <button className="user-biolink-chat-btn" onClick={() => user_token ? handleUnBlock() : handle_login()}>
                                                                                //     {spinner ?
                                                                                //         <ButtonLoader />
                                                                                //         : 'Unblock'}
                                                                                // </button>
                                                                                <Button
                                                                                    variant="secondary"
                                                                                    className="follower-action-btn-bio"
                                                                                    onClick={() => user_token ? handleUnBlock() : handle_login()}
                                                                                >
                                                                                    <FaBan className="me-2" />
                                                                                    Unblock
                                                                                </Button>
                                                                                :
                                                                                followerData?.user_status === 'pending' ?
                                                                                    // <button className="btn btn-sm btn-warning">
                                                                                    //     Pending
                                                                                    // </button> 
                                                                                    <Button
                                                                                        variant="warning"
                                                                                        className="follower-action-btn-bio"
                                                                                    >
                                                                                        <Clock12 className="me-2" />
                                                                                        Pending
                                                                                    </Button>
                                                                                    : ''
                                                    }
                                                    {followerData?.following_id?._id == localStorage.getItem('id') && followerData?.user_status === 'pending' ?

                                                        // <button className="user-biolink-chat-btn ms-2" onClick={() => user_token ? handleAccept() : handle_login()}>
                                                        //     {spinner ?
                                                        //         <ButtonLoader />
                                                        //         : 'Accept'}
                                                        // </button> 
                                                        <Button
                                                            variant="success"
                                                            className="follower-action-btn-bio"
                                                            onClick={() => user_token ? handleAccept() : handle_login()}
                                                        >
                                                            <FaCheck className="me-2" />
                                                            Accept
                                                        </Button>
                                                        : ''}
                                                    {
                                                        localStorage.getItem('id') === bioLinkdata?.user?._id || userbiolinkData?.FollowerData?.length == 0 || followerData?.user_status === 'unfollow' || followerData?.user_status === 'pending' || followerData?.user_status === 'blocked' ?
                                                            "" :

                                                            <Button
                                                                variant="primary"
                                                                className="follower-action-btn-bio follower-chat-btn"
                                                                onClick={() => user_token ? handleChat() : handle_login()}
                                                            >
                                                                <FaComments className="me-2" />
                                                                Chat
                                                                {chatNotificationData?.unreadCount > 0 && (
                                                                    <Badge bg="warning" text='dark' className='ms-1'>{chatNotificationData?.unreadCount}</Badge>
                                                                )}
                                                                <span className="visually-hidden">unread messages</span>
                                                            </Button>
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        {/* About Us Section */}
                                        {(showParagraph === true || showParagraph === 'true') ?
                                            <div className="user-biolink-about-section mt-5">
                                                <h2 className="user-biolink-about-title">About Me</h2>
                                                <p className="user-biolink-about-text">{paragraph}</p>
                                            </div>
                                            : ''}

                                        {/* Banner Image - All Screens (After About Me) */}
                                        {(showBanner === true || showBanner === 'true') ?
                                            <div className='banner_section mb-4'>
                                                <img
                                                    src={bannerImage ? bannerImageUrl : defaultBanner}
                                                    alt="banner"
                                                    style={{ objectFit: bannerImage ? 'contain' : 'cover', borderRadius: '10px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                                                    className="img-fluid user-biolink-banner"
                                                />
                                            </div>
                                            : ""}

                                        {/* YOUTUBE VIDEOS SECTION */}
                                        {youtubeVideos && Array.isArray(youtubeVideos) && youtubeVideos.length > 0 && (
                                            <div className='mt-2'>
                                                <h2 className="user-biolink-about-title">Content For You</h2>
                                                <div className="d-flex flex-wrap justify-content-center gap-3 mb-4 user-biolink-videos-section">
                                                    {youtubeVideos?.filter(video => !(video.is_hidden === true || video.is_hidden === 'true') && video.youtube_status !== 'deleted')?.map((video, index) => {
                                                        const video_id = video.video_id

                                                        // Robust thumbnail selection
                                                        let thumbnail = '';
                                                        if (video.thumbnail) {
                                                            thumbnail = video.thumbnail.startsWith('http')
                                                                ? video.thumbnail
                                                                : process.env.REACT_APP_BASE_URL + (video.thumbnail.startsWith('/') ? '' : '/') + video.thumbnail;
                                                        } else if (video_id) {
                                                            thumbnail = `https://img.youtube.com/vi/${video_id}/maxresdefault.jpg`;
                                                        }

                                                        const videoUrl = video.url || (video_id ? `https://www.youtube.com/watch?v=${video_id}` : '#')

                                                        return (
                                                            <div key={video.id || video._id || index} className="biolink-video-preview-item">
                                                                <a
                                                                    href={videoUrl}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="biolink-video-preview-link"
                                                                    onClick={() => {
                                                                        dispatch(youtubeAnalytics({ 'url': videoUrl, "profile_analytic_id": analyticsId, navigate }))
                                                                    }}
                                                                >
                                                                    {thumbnail ? (
                                                                        <img
                                                                            src={thumbnail}
                                                                            alt={video.url_name || "Video thumbnail"}
                                                                            className="biolink-video-preview-thumbnail"
                                                                            onError={(e) => {
                                                                                if (video_id) {
                                                                                    if (e.target.src.includes('maxresdefault')) {
                                                                                        e.target.src = `https://img.youtube.com/vi/${video_id}/hqdefault.jpg`;
                                                                                    } else {
                                                                                        e.target.style.display = 'none';
                                                                                        e.target.nextSibling.style.display = 'flex';
                                                                                    }
                                                                                } else {
                                                                                    e.target.style.display = 'none';
                                                                                    e.target.nextSibling.style.display = 'flex';
                                                                                }
                                                                            }}
                                                                        />
                                                                    ) : null}
                                                                    <div className="biolink-video-preview-placeholder" style={{ display: thumbnail ? 'none' : 'flex' }}>
                                                                        {/* Placeholder stays hidden if thumbnail exists and loads */}
                                                                    </div>
                                                                    <div className="biolink-video-preview-overlay">
                                                                        {/* <div className="biolink-video-preview-play-icon"> */}
                                                                        <img src={thumbImage} alt="" height={'30px'} style={{ borderRadius: '50%' }} />
                                                                        {/* </div> */}
                                                                    </div>
                                                                </a>
                                                                {video.url_name && (
                                                                    <div className="biolink-video-preview-name">
                                                                        {video.url_name}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        )}

                                        {/* Social Links Section */}
                                        {socialLinks.filter(link => !(link.is_hidden === true || link.is_hidden === 'true') && link.social_status !== 'deleted').length > 0 && (
                                            <div className="user-biolink-social-section mt-4">
                                                <h2 className="user-biolink-social-title">Connect With Me</h2>
                                                <div className="user-biolink-social-links">
                                                    {socialLinks?.filter(link => !(link.is_hidden === true || link.is_hidden === 'true') && link.social_status !== 'deleted')?.map((link, index) => {
                                                        const linkId = link.id || link._id || index
                                                        const linkName = link.name || 'Link'
                                                        return (
                                                            <a
                                                                key={linkId}
                                                                href={link.url}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="user-biolink-social-link"
                                                                onClick={() => {
                                                                    dispatch(socialAnalytics({
                                                                        social_link_id: link._id || link.id,
                                                                        profile_analytic_id: analyticsId,
                                                                        social_url: link.url,
                                                                        navigate,
                                                                    }))
                                                                }}
                                                            >
                                                                {linkName}
                                                            </a>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            }
            <Footer />

            {/* Chat OffCanvas */}
            {user_token && chatFollower && (
                <ChatBox
                    show={showChat}
                    onHide={handleCloseChat}
                    chatFollower={chatFollower}
                    qrCode2={bioLinkdata}
                // fetchMessages={fetchMessages}
                // sendMessage={sendMessage}
                />
            )}
        </>
    )
}
